import { connect } from 'react-redux';
import { componentsConfiguration } from '../../selectors';
import ConfiguredComponentLoader from './ConfiguredComponentLoader.component';

export const mapStateToProps = state => ({
  components: componentsConfiguration(state),
});

export default connect(mapStateToProps)(ConfiguredComponentLoader);
